import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Unlike react-router 6's `<Navigate>`, which navigates again after every
 * render, this replaces the location once per mount.
 */
export const RedirectOnce = ({ to }: { to: string }) => {
  const navigate = useNavigate();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;
    navigate(to, { replace: true });
  }, [navigate, to]);

  return null;
};
